import {useSetAndCacheFilter} from './use_set_and_cache_filter'

export const useClearFilters = ({orgCacheKey, name}) => {
	const clearFilterFn = useSetAndCacheFilter({orgCacheKey, name, clearFilters: true})
	return () => clearFilterFn()
}
